export const ColorColumns = [
    "SNo",
    "ColorCode",
    "ColorName"
  ]